import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../_helpers/appconfig.service';
import { ImportFileOptions } from '../sharedcomp/constans/importProcess.constans';
import { BatchFile, DataValidation, FieldValidation, FileValidation, PaymentVersion, PayoutVersion } from '../_models';

@Injectable({
  providedIn: 'root'
})

export class NewImportProcessService {
  _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();

  protected kcmssvcURL = this._kcmssvcURL;

  httpOptions: any;
  public defaultHeaders = new HttpHeaders();
  constructor(private http: HttpClient) { }


  fileValidation<T = PayoutVersion>(body: FormData, url: string, observe: any = 'body', reportProgress: boolean = false): Observable<FileValidation<T>> {
    if (body == null) {
      throw new Error('Required parameter body was null or undefined when calling file validation.');
    }

    let headers = this.defaultHeaders;
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    return this.http.post<FileValidation<T>>(`${this.kcmssvcURL}/${url}/file_validation`,
      body,
      {
        headers: headers
      }
    );
  }

  newFileValidation<T = PaymentVersion>(body: FormData, url: string, observe: any = 'body', reportProgress: boolean = false): Observable<FileValidation<T>> {
    if (body == null) {
      throw new Error('Required parameter body was null or undefined when calling file validation.');
    }

    let headers = this.defaultHeaders;
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    return this.http.post<FileValidation<T>>(`${this.kcmssvcURL}/debtors_process/file_validation`,
      body,
      {
        headers: headers
      }
    );
  }

  dataValidation(body: FormData, publicId: BatchFile['id'], url: string, observe: any = 'body', reportProgress: boolean = false): Observable<HttpResponse<DataValidation>> {
    if (body == null) {
      throw new Error('Required parameter body was null or undefined when file rendering.');
    }

    let headers = this.defaultHeaders;
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    return this.http.post<DataValidation>(`${this.kcmssvcURL}/${url}/data_validation/${publicId}`,
      body,
      {
        headers: headers,
        observe: 'response'
      }
    );
  }

  newDataValidation(body: FormData, publicId: BatchFile['id'], url: string, observe: any = 'body', reportProgress: boolean = false): Observable<HttpResponse<DataValidation>> {
    if (body == null) {
      throw new Error('Required parameter body was null or undefined when file rendering.');
    }

    let headers = this.defaultHeaders;
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    return this.http.post<DataValidation>(`${this.kcmssvcURL}/debtors_process/data_validation/${publicId}`,
      body,
      {
        headers: headers,
        observe: 'response'
      }
    );
  }

  fieldValidation(body: FormData, url: string, publicId: BatchFile['id'], observe: any = 'body', reportProgress: boolean = false): Observable<FieldValidation> {
    if (body == null) {
      throw new Error('Required parameter body was null or undefined when calling verify file validation.');
    }

    let headers = this.defaultHeaders;
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    return this.http.post<FieldValidation>(`${this.kcmssvcURL}/${url}/field_validation/${publicId}`,
      body,
      {
        headers: headers
      }
    );
  }
  newFieldValidation(body: FormData, url: string, publicId: BatchFile['id'], observe: any = 'body', reportProgress: boolean = false): Observable<FieldValidation> {
    if (body == null) {
      throw new Error('Required parameter body was null or undefined when calling verify file validation.');
    }

    let headers = this.defaultHeaders;
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    return this.http.post<FieldValidation>(`${this.kcmssvcURL}/debtors_process/field_validation/${publicId}`,
      body,
      {
        headers: headers
      }
    );
  }

}
